import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import React from 'react'

export default function Stencil() {
  return (
    <Typography>
      <Link href="https://www.reddit.com/r/YangForPresidentHQ/comments/dyvymt/how_to_create_the_effective_yanggang_rally_signs/">
        This is how you use this stencil
      </Link>
    </Typography>
  )
}
